module.exports = __webpack_public_path__ + "img/idea.573305eb.svg";